<template>
  <div class="login-div">


    <!-- 表格 -->
    <div class="tableCon" style="margin-top: 40px">
      <div class="top flexBC"  v-if="roleType!=3">
        <div>
          <Button
            type="success"
            class="addButton"
            @click="addNewP(1)"
            :disabled="page.total>=5"
            style="margin-right: 8px"
            >{{ $t("add") }}</Button
          >
        </div>
      </div>


      <Table
        style="width: 100%; margin-top: 30px"
        :columns="titleName"
        :data="tableList.tableData"
        ref="selection"
        @on-sort-change="sortCustom"
        :loading="loading"
      ></Table>
    </div>

    <!-- 新增、编辑 -->
    <ModelBox
      :showModel.sync="addBox.showModel"
      :fn="addBox.callbackFn"
      :type="type"
      :editFormData="addBox.editFormData"
    ></ModelBox>
   
    <!-- 删除 -->
    <DeleteDialog ref="deleteChild" @ievent="ievent"></DeleteDialog>

  </div>
</template>

<script>
import common from "@/common/common.js";
import moment from "moment";
import ModelBox from "./component/addModel";
import DeleteDialog from "../common/deleteModel.vue"; // 引入删除弹框组件
import { mapState } from "vuex";

export default {
  name: "deviceManage",
  components: {
    ModelBox,
    DeleteDialog,
  },
  data() {
    return {
      loading: true,
      type: 1, //弹框打开类型 1添加 2编辑
      tableList: {
        //表格组
        hasSelectData: {}, //已选中的行的数据
        tableData: [], //表格数据
        tableDataAll: [],
      },
      buttonList: {
        //按钮组
        editDisabled: true, //编辑按钮是否禁用
        publishedDisabled: false, //编辑按钮是否禁用
      },
      addBox: {
        //规格弹框组-新增编辑
        showModel: false, //弹框开关
        callbackFn: () => {}, //弹框的回调函数
        editFormData: {}, //编辑时传入的现有数据
      },
      paging: true,//分页是否是真的
      page: {
        //分页排序
        total: 0, //总条数
        pageSize: 10, //每页条数
        current: 1, //当前页
        key: "id",
        order: "desc",
      },
    };
  },
  computed: {
    ...mapState(["local", "selectId"]),
    roleType(){
	    	 let res = 3
	    	 if(this.$store.state.uInfo && this.$store.state.uInfo.roleType){
	    		 res = this.$store.state.uInfo.roleType
	    	 }
	    	 return res
	   },
    
    titleName() {
      return [
        {
          title: this.$t("BasicProduct.titleName.imageId"),
          key: "id",
          minWidth: 150,
          render: (h, params) => {
            let photo = params.row.imageId
            return h(
              "div",
              {
                style: {
                  "over-flow": "hidden",
                  height: "63px",
                  position: "relative",
                },
              },
              [
                h("img", {
                  attrs: {
                    src: this.config.sourceUrl + "?fid=" + photo,
                  },
                  style: {
                    height: "100%",
                    "vertical-align": "middle",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%,-50%)",
                  },
                }),
              ]
            );
          },
        },
        {
          title: this.$t("onboardingBanner.link"),
          key: "businessUrl",
          minWidth: 300,
        },
        {
          title: this.$t("onboardingBanner.order"),
          key: "sortNum",
          minWidth: 150,
          sortable: true,
        },
        {
          title: this.$t("productManage.addModel.CreateTime"),
          key: "createDate",
          minWidth: 180,
          render: (h, params) => {
            let stext = moment(params.row.createDate * 1).format(
              "YYYY-MM-DD HH:mm:ss"
            );
            return h("div", stext || "");
          },
        },
        {
					title: this.$t('orderManage.titleName.Operation'),
					minWidth:this.roleType ==1?220 :120,
          key: "id",
					render: (h, params) => {
             let that = this
             return [h('div',
                        { 
                           style:{
                              display: "flex",
                              justifyContent:'center'
                            }
                         },[
                              h('Button', {
					                          props: {
                                          type: "info",
                                          size: 'small'
                                      },
                                      style:{
                                          'margin-right':'5px',
                                      },
					                          on: {
					                              click: () => { this.addNewP(2,params.row) }
					                          }
					                      }, that.$t("edit")),
                              h('Button', {
					                        props: {
                                      type: "error",
                                      size: 'small'
                                  },
                                  style:{
                                      'margin-right':'5px',
                                  },
					                        on: {
					                            click: () => { this.delData(params.row) }
					                        }
					                    }, that.$t("delete")),
                           ]
                     )]
					}
				},
      ];
    },
  },
  created() {
    this.getData();
  },
  mounted() {
  },
  methods: {
   
    delData(item) {// 删除
      this.tableList.hasSelectData = item
      this.$refs.deleteChild.showit();
    },
    ievent() {// 删除
      
      // console.log("删除");
      let url = this.config.urlArray.deleteAdvertise;
      this.axios
        .post(url, { id: this.tableList.hasSelectData.id })
        .then((result) => {
          common.ajaxMsg(result.data, true, () => {
            this.$refs.deleteChild.recancel();
            this.clearbtnStatus();
            this.getData();
          },()=>{
            this.$refs.deleteChild.recancel();

          });
        })
        .catch((err) => {
          // common.msg('error',this.$t('failed'))
        });
    },

    addNewP(type, item = {}) {//创建产品数据
      
      this.addBox.showModel = true;
      this.type = type;
      this.tableList.hasSelectData = {}
      if (type == 2) {
        this.tableList.hasSelectData = item
        this.addBox.editFormData = this.tableList.hasSelectData;
      }
      this.addBox.callbackFn = () => {
        //回调处理
        //重新载入
        this.addBox.showModel = false;
        this.clearbtnStatus();
        this.getData();
      };
    },
    
    searchItem() {//搜索
      this.page.current = 1
      this.page.pageSize = 10
      this.getData();
    },
    getData() {//获取数据
      
      // let querySearch = this.searchObj.published?'/'+this.searchObj.published:''
      let params = {
        page: this.page.current,
        limit: this.page.pageSize,
        key: this.page.key,
        order: this.page.order,
        ...this.searchObj,
      };

      // Object.assign(getData.params,this.searchObj)
      this.loading = true;

      this.axios
        .post(this.config.urlArray.getAdvertises, {
          ...params,
          dealerId: this.selectId,
        })
        .then((result) => {
          common.ajaxMsg(result.data,false);
          let resData = result.data.data;
          //处理数组
          if (resData) {
            this.tableList.tableData = resData  
            this.page.total = resData.length;  
          } else {
            this.tableList.tableData = [];
            this.page.total = 0;
            return false;
          }

          this.loading = false;
        })
        .catch((err) => {
          // common.msg('error','获取失败',()=>{})
        });
    },
  
    sortCustom(data) {//自定义排序
      
      this.page.key = data.key;
      this.page.order = data.order;
      this.getData();
    },

    changePage(nowpage) {//切换分页
      
      this.page.current = nowpage;
      this.getData();
    },
    changeSize(nowSize) {//切换每页显示条数
      
      this.page.pageSize = nowSize;
      this.page.current = 1;
      this.getData();
    },
    clearbtnStatus() {//删除后清空编辑数据 与按钮状态
      
      this.buttonList.editDisabled = true;
      this.buttonList.publishedDisabled = false;
      this.tableList.hasSelectData = {};
    },
  },
};
</script>
 <style scoped lang="less">
.goodsCon {
  flex-wrap: wrap;
  .goodsItem {
    width: 22.5%;
    margin-left: 2%;
    background-color: #fff;
    border: 2px solid #e5e5e5;
    border-radius: 10px;
    padding: 20px 30px;
    margin-bottom: 40px;
    min-width: 193px;
    overflow-x: hidden;
    cursor: pointer;
    .imgCon {
      width: 120px;
      height: 120px;
      margin: 0 auto;
      img {
        width: auto;
        height: 100%;
        max-width: calc(100% + 90px);
      }
    }
    .goodName {
      color: #3a464e;
      margin-top: 7px;
      text-align: center;
    }
    .bottomInfo {
      margin-top: 40px;
      color: #3a464e;
      text-align: center;
      line-height: normal;
      .desc {
        font-size: 12px;
        color: #a4b4bf;
        margin-top: 15px;
      }
      .dataNum {
        height: 26px;
        line-height: 26px;
      }
      .numCon {
        font-size: 20px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        color: #e76d6a;
      }
    }
  }
}
.labelText {
  line-height: 54px;
  height: 54px;
  flex-shrink: 0;
  margin-right: 10px;
}
.echartsCon {
  background: #fff;
  margin: 40px 40px;
  border-radius: 14px;
  padding: 20px 40px;
  #main {
    // width: 100%;
    flex-grow: 1;
    height: 400px;
    margin: auto;
    margin-top: 30px;
  }
  .titleCon {
    width: 350px;
    flex-shrink: 0;
    .titleConItem {
      border-bottom: 2px solid #eef1f4;
      padding: 20px 18px 20px 35px;
      color: #3a464e;
      position: relative;
      &:nth-last-of-type(1) {
        border-bottom: none;
      }
      &::before {
        content: "";
        position: absolute;
        left: 12px;
        top: 50%;
        transform: translateY(-50%);
        width: 6px;
        height: 26px;
        background: #4e77ef;
      }
      &:nth-of-type(2) {
        &::before {
          background: #ffb139;
        }
      }
      &:nth-of-type(3) {
        &::before {
          background: #3bc1db;
        }
      }

      .num {
        font-size: 20px;
        font-weight: bold;
      }
      .desc {
        line-height: normal;
      }
    }
  }
}

.search-div {
  flex-wrap: wrap;
  background-color: #fff;
  padding: 34px 40px;
  background: #ffffff;
  margin: 40px 40px 0px;
  border-radius: 14px;
  .search-div-item {
    margin-right: 20px;
    span {
      margin-right: 30px;
    }
  }
  /deep/ .ivu-select-single .ivu-select-selection .ivu-select-placeholder,
  .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
    height: 44px;
    line-height: 44px;
  }
  /deep/ .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
    height: 44px;
    line-height: 44px;
  }
  /deep/ .ivu-select-single .ivu-select-selection {
    height: 44px;
    width: 200px;
  }
  /deep/ .ivu-input {
    height: 44px;
    line-height: 44px;
  }
  /deep/ .ivu-input-icon {
    height: 44px;
    line-height: 44px;
  }
}

.tableCon {
  background-color: #fff;
  padding: 34px 40px 30px 34px;
  background: #ffffff;
  margin: 20px 40px;
  border-radius: 14px;
  //  min-height: 78vh;
  .top {
    margin: 0 0 30px;
    .optionsIcon {
      margin-right: 15px;
    }
    .moveBotton {
      background: #3bc1db;
      color: #fff;
      border-color: #3bc1db;
      border-radius: 6px;
    }
  }
}
.login-div {
  min-height: calc(100vh - 128px);
}
/deep/ .ivu-table td,
.ivu-table th {
  height: 70px;
}
//  /deep/ .ivu-table-fixed-body{
//      height: 100% !important;
//      max-height: 710px;
//  }
</style>
